import { render, staticRenderFns } from "./chat-info.html?vue&type=template&id=25f99fdb&scoped=true&"
import script from "./chat-info.js?vue&type=script&lang=js&"
export * from "./chat-info.js?vue&type=script&lang=js&"
import style0 from "./chat-info.scss?vue&type=style&index=0&id=25f99fdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f99fdb",
  null
  
)

export default component.exports